export function ensureHttps(url: string): string {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `https://${url}`;
  }
  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  return url;
}

export function clearURLProtocol(url: string) {
  return url.replace(/^https?:\/\/(www\.)?/, '');
}
